import useAppStore from "@/store/use-app-store";
import { KeyOff } from "@mui/icons-material";
import {
  Box,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { getCertificate, getUserCertificates } from "crypto-pro";
import {
  dateToString,
  getLocalStorageItem,
  isIdentical,
  isObjectEmpty,
  parseRFC3339,
  validArray,
} from "data/functions";
import React, { useEffect, useState } from "react";

function Certificate({ onChange }) {
  const [certificates, setCertificates] = useState([]);
  const [certificatesError, setCertificatesError] = useState([]);
  const [certificate, setCertificate] = useState(null);
  const [certificateDetails, setCertificateDetails] = useState(null);
  const [detailsError, setDetailsError] = useState(null);
  const { isMobile } = useAppStore();

  function selectCertificate(n, t) {
    console.log(t);
    const certificate = certificates.find(
      ({ name, thumbprint }) => n === name && t === thumbprint,
    );
    setCertificate(certificate);
    onChange(certificate);
  }

  async function loadCertificateDetails(thumbprint) {
    try {
      const certificate = await getCertificate(thumbprint);

      setCertificateDetails({
        "'1.3.6.1.5.5.7.3.3', '1.3.6.1.4.1.311.10.3.12'":
          await certificate.hasExtendedKeyUsage([
            "1.3.6.1.5.5.7.3.3",
            "1.3.6.1.4.1.311.10.3.12",
          ]),
        "1.3.6.1.4.1.311.80.1": await certificate.hasExtendedKeyUsage(
          "1.3.6.1.4.1.311.80.1",
        ),
        "1.3.6.1.4.1.311.80.2": await certificate.hasExtendedKeyUsage(
          "1.3.6.1.4.1.311.80.2",
        ),
        "['1.3.6.1.5.5.7.3.2', '1.3.6.1.4.1.311.10.3.12']":
          await certificate.hasExtendedKeyUsage([
            "1.3.6.1.5.5.7.3.2",
            "1.3.6.1.4.1.311.10.3.12",
          ]),
        algorithm: await certificate.getAlgorithm(),
        base64: await certificate.exportBase64(),
        decodedExtendedKeyUsage: await certificate.getDecodedExtendedKeyUsage(),
        extendedKeyUsage: await certificate.getExtendedKeyUsage(),
        isValid: await certificate.isValid(),
        issuerInfo: await certificate.getIssuerInfo(),
        issuerName: certificate.issuerName,
        name: certificate.name,
        ownerInfo: await certificate.getOwnerInfo(),
        subjectName: certificate.subjectName,
        thumbprint: certificate.thumbprint,
        validFrom: certificate.validFrom,
        validTo: certificate.validTo,
        version: await certificate.getCadesProp("Version"),
      });
    } catch (error) {
      setDetailsError(error);
    }
  }

  // useEffect(() => {
  //   console.log(certificateDetails);
  // }, [certificateDetails]);

  useEffect(() => {
    (async () => {
      try {
        if (!isObjectEmpty(certificate)) return;
        let serts = await getUserCertificates();
        setCertificates(serts);
        let existThumbprint = getLocalStorageItem("data_certificateThumbprint");
        if (!isObjectEmpty(existThumbprint)) {
          let find = validArray(serts, "").find(
            (e) => e?.thumbprint === existThumbprint,
          );
          if (find) {
            selectCertificate(find?.thumbprint);
          } else {
            useAppStore.setState({ certificateThumbprint: "" });
          }
        }
      } catch (error) {
        setCertificatesError(error.message);
      }
    })();
  }, []);

  return (
    <>
      <Typography sx={{ margin: "6px 0" }} variant="h6">
        Выбор сертификата:
      </Typography>
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <KeyOff />
            </InputAdornment>
          ),
          style: {
            fontSize: isMobile ? "0.875rem" : "1rem",
          },
        }}
        // defaultValue=""
        error={!isObjectEmpty(certificatesError) ? true : false}
        fullWidth
        helperText={!isObjectEmpty(certificatesError) ? certificatesError : ""}
        mb={2}
        mt={2}
        name="department"
        select
        // sx={{
        //   margin: "0.3rem 0",
        //   minWidth: dataObj?.deviceWidth?.isMobile ? "inherit" : "30%",
        // }}
        type="text"
        value={certificate?.thumbprint || ""}
        variant="standard"
      >
        {validArray(certificates, "Certificate.render")?.map(
          ({ name, thumbprint, validTo }) => (
            <MenuItem
              key={thumbprint}
              onClick={(e) => selectCertificate(name, thumbprint)}
              value={thumbprint}
            >
              {name}
            </MenuItem>
          ),
        )}
        {isObjectEmpty(certificates) && (
          <MenuItem>Сертификаты не найдены</MenuItem>
        )}
      </TextField>
      {/* <br />

      <select id="certificate" onChange={selectCertificate}>
        <option defaultValue={null}>Не выбран</option>

        {certificates.map(({ name, thumbprint, validTo }) => (
          <option key={thumbprint} value={thumbprint}>
            {name + " (действителен до: " + validTo + ")"}
          </option>
        ))}
      </select> */}

      {/* <pre>{certificatesError || null}</pre> */}

      {certificate ? (
        <>
          <Box
            sx={{
              border: "1px solid",
              borderRadius: "12px",
              margin: "12px 0",
              padding: "6px",
            }}
          >
            {/* <Typography sx={{ margin: "6px 0" }} variant="body1">
              Информация о сертификате
            </Typography> */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1">{certificate?.name}</Typography>
              <Typography variant="body1">
                Действителен до{" "}
                {dateToString(parseRFC3339(certificate?.validTo))}
              </Typography>
              {/* <Typography variant="body1">
                Истекает: {dateToString(parseRFC3339(certificate?.validTo))}
              </Typography> */}
            </Box>
            {/* <Box>{certificate?.validFrom}</Box>
            <Box>{certificate?.validTo}</Box> */}
          </Box>
        </>
      ) : null}
    </>
  );
}

export default Certificate;
